import { MapPin, RefreshCw, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

interface MapFallbackProps {
  onRetry?: () => void;
  error?: string;
  isLoading?: boolean;
}

export const MapFallback = ({ onRetry, error, isLoading }: MapFallbackProps) => {
  // Estado de carregamento
  if (isLoading) {
    return (
      <Card className="w-full h-full flex flex-col items-center justify-center p-8 bg-gradient-to-br from-primary/20 to-primary/5">
        <div className="flex flex-col items-center gap-4 text-center max-w-md">
          <Loader2 className="w-12 h-12 animate-spin text-primary" />
          <h3 className="text-lg font-semibold">Gerando Mapa...</h3>
          <p className="text-sm text-muted-foreground">
            Aguarde enquanto processamos seus dados GPS
          </p>
        </div>
      </Card>
    );
  }

  // Estado de erro ou GPS insuficiente
  return (
    <Card className="w-full h-full flex flex-col items-center justify-center p-8 bg-gradient-to-br from-orange-500/10 to-orange-500/5">
      <div className="flex flex-col items-center gap-4 text-center max-w-md">
        <div className="w-20 h-20 rounded-full bg-orange-500/20 flex items-center justify-center">
          <MapPin className="w-10 h-10 text-orange-500 animate-pulse" />
        </div>
        
        <div>
          <h3 className="text-lg font-semibold mb-2">
            Aguardando Dados GPS
          </h3>
          <p className="text-sm text-muted-foreground">
            {error || "Continue correndo para gerar seu mapa! Precisamos de pelo menos 30 segundos de dados GPS para criar uma visualização perfeita."}
          </p>
        </div>

        {onRetry && (
          <Button 
            onClick={onRetry} 
            variant="outline" 
            className="mt-2"
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Tentar Novamente
          </Button>
        )}

        <div className="mt-4 p-4 bg-background/50 rounded-lg border border-border/50">
          <p className="text-xs text-muted-foreground">
            💡 Dica: O mapa ficará disponível automaticamente quando houver dados GPS suficientes.
          </p>
        </div>
      </div>
    </Card>
  );
};
